var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPulse = function SvgPulse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 11.002h2.5a1 1 0 0 0 .894-.552l.793-1.575 1.343 5.368a1 1 0 0 0 1.935.021l2.059-7.535 1.014 3.548a1 1 0 0 0 .962.725H15a1 1 0 0 0 0-2h-1.744l-1.794-6.276a1 1 0 0 0-1.927.012L7.544 10.05 6.47 5.757a1 1 0 0 0-1.864-.2L2.88 9.002H1a1 1 0 0 0 0 2Z",
    clipRule: "evenodd"
  })));
};
export default SvgPulse;